/**
 * Construye URL para archivos estáticos servidos bajo config.url + config.paths.
 */
export function getAssetUrl(config, pathKey, fileName) {
  if (!fileName || typeof fileName !== "string") return null;

  const trimmed = fileName.trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const base = (config?.url || "").replace(/\/$/, "");

  if (trimmed.startsWith("/")) {
    return `${base}${trimmed}`;
  }

  if (trimmed.includes("/")) {
    return `${base}/${trimmed.replace(/^\//, "")}`;
  }

  const folder = config?.paths?.[pathKey];
  if (!folder) return null;

  return `${base}/${folder}/${encodeURIComponent(trimmed)}`;
}
